import { some } from 'lodash-es';
import { mapMutations, mapState } from 'vuex';
import FormGroup from '@maison/components/form/FormGroup';
import RadioListField from '@maison/components/form/fields/RadioListField';
import CheckboxField from '@maison/components/form/fields/CheckboxField.vue';
import TextField from '@maison/components/form/fields/TextField.vue';
import PhoneField from '@maison/components/form/fields/PhoneField.vue';
import * as types from '@phoenix/store/mutations-types';
import { configureVeeValidate, convertFormDataToData } from '@phoenix/helpers/form-helper';

configureVeeValidate();

export default {
  components: {
    FormGroup,
    RadioListField,
    TextField,
    PhoneField,
    CheckboxField,
  },

  data() {
    return {
      fields: {
        phone: {
          id: 'phone',
          name: 'phone',
          label: this.$t('Form.label.phone'),
          value: '',
          required: true,
        },
        email: {
          id: 'email',
          name: 'email',
          label: this.$t('Form.label.email'),
          value: '',
          required: true,
          type: 'email',
        },
        preferredContact: {
          id: 'preferredContact',
          name: 'preferredContact',
          label: this.$t('Form.label.preferedContactMode'),
          value: [],
          options: [],
        },
      },
    };
  },

  created() {
    this.setPreferredContactModeFieldOptions();

    if (window.Phoenix.currentCountry === 'CN') {
      this.fields.email.required = false;
    }
  },

  computed: {
    ...mapState('lightCheckout', ['contactStepConfirmed', 'contactInformations']),

    hasPreferredContactMethodSelected() {
      return some(this.contactInformations.preferredContact);
    },

    formValues() {
      return convertFormDataToData(this.fields);
    },
  },

  methods: {
    ...mapMutations('lightCheckout', [
      types.LIGHT_CHECKOUT_SET_CONTACT_INFORMATIONS,
      types.LIGHT_CHECKOUT_EDIT_CONTACT_INFORMATIONS,
    ]),

    setPreferredContactModeFieldOptions() {},

    async confirmContactInfo() {
      this.setValues(this.formValues);
      const { valid } = await this.validate();

      if (!valid) {
        return;
      }

      this.LIGHT_CHECKOUT_SET_CONTACT_INFORMATIONS({
        phone: this.fields.phone.value,
        email: this.fields.email.value,
        preferredContact: this.fields.preferredContact.value,
      });
    },

    editContact() {
      this.LIGHT_CHECKOUT_EDIT_CONTACT_INFORMATIONS();
      this.$nextTick(() => this.$refs.emailField.$refs.email.focus());
    },
  },
};
